import {useCompanyId, usePlatformUrls} from "../../../core";
import {
  AMCompanyModel,
  AmVersion,
  getStoreId,
  isFinalStateOfScenario,
  PFAScenarioConfiguration,
  ProjectCreationPFATScenarioConfiguration,
  ProjectCreationScenarioConfiguration,
  ProjectPricingScenarioConfiguration,
  WhatIfScenarioConfig,
  WhatIfScenarioRecord
} from "../../../ps-types";
import {useEffect, useState, useRef} from "react";
import {getWhatIfScenario, listWhatIfScenarios, runWhatIfScenarioDirectlyForQAT, updateWhatIfScenario} from "../whatIfScenarios.client";
import {Button as SemanticButton, Icon, Header, Button} from "semantic-ui-react";
import {LoadingBlock} from "../../../ui/Loading";
import {useMessages} from "../../../ui/MessagesProvider";
import {GlobalInputs} from "../GlobalInputs";
import { getAmProjects } from "../../projects/amProject.client";
import {v4 as uuidv4} from "uuid";
import { authStorage } from "../../../auth";
import { getAmProjectConfig } from "../../../ps-models";
import { buildLineItemsStorePersistence } from "../../../lineitems-store/RestLineItemsStore.persistence";
import { LineItemsStore } from "../../../ps-models/lineitems-store";
import { PSCard } from "../../../ui/PSCard";
import {
  Box,
  TextField,
  Typography,
} from '@mui/material';
import { useForm } from "../../../ui/UseForm";
import "../../../campaigns/ICP4/ICP4SignUpPage.css";
import { QATCampaignSignUpData } from "../../../campaigns/QAT/QATSignup.client";
import { useHistory } from "react-router-dom";
import { CPFATResultBlock, PFAResultBlock, ProjectCreationResultBlock, ProjectPricingResultBlock } from "./QuickAnalysisToolsResultComponents";
import { getAmCompanyModels } from "../../../company/company.client";
import { usePopup } from "../../../ui/popup/Popup";
import { ContentPopup } from "../../../ui/popup/ContentPopup";
import { ProjectVersionMappingLogs } from "../../projects/ProjectTemplate.page";

const persistence = buildLineItemsStorePersistence();

export function QuickAnalysisToolPage({kind}: {kind: "PFA" | "Project-Pricing" | "Create-Project" | "CPFAT"}) {
  const [QATProjectId, setQATProjectId] = useState<string>();
  const [scenario, setScenario] = useState<WhatIfScenarioRecord>();
  const [scenarioStatus, setScenarioStatus] = useState<WhatIfScenarioRecord['status']>();
  const [loading, setLoading] = useState<boolean>(true);
  const [running, setRunning] = useState<boolean>(false);
  const [versionData, setVersionData] = useState<AmVersion>();
  const [resultantStore, setResultantStore] = useState<LineItemsStore | undefined>(undefined);
  const [config, setConfig] = useState<WhatIfScenarioConfig | undefined>(undefined);
  const {error: errorMessage, clear} = useMessages();
  let {openPopup, closePopup}   = usePopup();
  const history = useHistory();
  const {dealManagement, amProjectDetails, developmentProjectsProjectsList} = usePlatformUrls();
  const resultBlockRef = useRef<HTMLDivElement>(null);

  const companyId = useCompanyId();
  const company = authStorage.getCompany();
  let { collection } = getAmProjectConfig(company);
  const { formData, handleChange, handleSubmit, submitting, error } = useForm<QATCampaignSignUpData>({
    initialState: {
        firstName: '',
        lastName: '',
        email: '',
        status: "enabled",
        userProvidedCompanyName: '',
        campaign: kind,
        phoneData: {
            phoneNumber: '',
            countryCode: 'US'
        }
    },
    onSubmit: async (data) => {
      // @TODO: Do something here
    }
})

  const scenarioKind = kind === 'PFA' ? 'pfa-scenario' : ((kind === 'Create-Project' || kind === 'CPFAT') ? 'create-project' : 'project-pricing-scenario');
  const projectKind = kind;

  useEffect(() => {
    async function load() {
      let projects = await ((kind !== 'Create-Project' && kind !== 'CPFAT') ? getAmProjects(companyId, projectKind as "PFA" | "Project-Pricing") : null);
      let firstProjectId = projects?.[0]?.id ?? uuidv4().substring(0, 8);
      let pfaScenario = (await listWhatIfScenarios(companyId, scenarioKind))[0];
      let models: AMCompanyModel[]=[];
      
      if(kind === 'Create-Project' || kind === 'CPFAT') {
        models = await getAmCompanyModels(companyId);
        setConfig(kind === 'Create-Project' ? ProjectCreationScenarioConfiguration : ProjectCreationPFATScenarioConfiguration);
      } else {
        setConfig(kind === 'PFA' ? PFAScenarioConfiguration : ProjectPricingScenarioConfiguration);
      }
      const scenarioRecord = await getWhatIfScenario(companyId, pfaScenario.scenarioId);
      setQATProjectId(firstProjectId);
      if(models && !scenarioRecord?.modelId) {
        scenarioRecord.modelId = models.filter((it)=>it.type === "Project")?.[0]?.id;
      }
      if(kind === 'CPFAT') {
        scenarioRecord.configurationName = "project-creation-pfat-assumptions";
      }
      console.info("The scenario record is", scenarioRecord);
      if(Object.keys(scenarioRecord.inputData?.globalInputs ?? {}).length === 0) {
        scenarioRecord.inputData.globalInputs = {
          // "project-name": {
          //     "valueKey": "project-name",
          //     "value": [
          //         [
          //             "Hema Land 2"
          //         ]
          //     ]
          // },
          "construction-beginning-date": {
              "valueKey": "construction-beginning-date",
              "value": [
                  [
                      "11/01/2025"
                  ]
              ]
          },
          // "construction-period-months": {
          //     "valueKey": "construction-period-months",
          //     "value": [
          //         [
          //             4
          //         ]
          //     ]
          // },
          "model-period-year": {
              "valueKey": "model-period-year",
              "value": [
                  [
                      25
                  ]
              ]
          },
          // "address-line-1": {
          //     "valueKey": "address-line-1",
          //     "value": [
          //         [
          //             "5903 Southwest Pkwy"
          //         ]
          //     ]
          // },
          // "county": {
          //     "valueKey": "county",
          //     "value": [
          //         [
          //             "Austin"
          //         ]
          //     ]
          // },
          "state": {
              "valueKey": "state",
              "value": [
                  [
                      "Texas"
                  ]
              ]
          },
          // "zip-code": {
          //     "valueKey": "zip-code",
          //     "value": [
          //         [
          //             78735
          //         ]
          //     ]
          // },
          "pv-system-size-kW-DC": {
              "valueKey": "pv-system-size-kW-DC",
              "value": [
                  [
                    344.6
                  ]
              ]
          },
          "pv-system-size-kW-AC": {
              "valueKey": "pv-system-size-kW-AC",
              "value": [
                  [
                      300
                  ]
              ]
          },
          "residential-avoided-rate-($/kWh)": {
              "valueKey": "residential-avoided-rate-($/kWh)",
              "value": [
                  [
                      0.1124
                  ]
              ]
          },
          // "Discount": {
          //     "valueKey": "Discount",
          //     "value": [
          //         [
          //             0
          //         ]
          //     ]
          // },
          "residential-ppa-rate-$/kWh)": {
              "valueKey": "residential-ppa-rate-$/kWh)",
              "value": [
                  [
                    0.1124
                  ]
              ]
          },
          "ppa-rate-escalator-(%)": {
              "valueKey": "ppa-rate-escalator-(%)",
              "value": [
                  [
                      3
                  ]
              ]
          },
          "system-cost-($/watt dc)": {
            "valueKey": "system-cost-($/watt dc)",
            "value": [
                [
                    1.8
                ]
            ]
        },
          "debt-interest-rate": {
              "valueKey": "debt-interest-rate",
              "value": [
                  [
                      9.5
                  ]
              ]
          },
          "debt-term": {
              "valueKey": "debt-term",
              "value": [
                  [
                      20
                  ]
              ]
          },
          "surface-area-sqft": {
              "valueKey": "surface-area-sqft",
              "value": [
                  [
                      25000
                  ]
              ]
          },
          "lease-$/sqft": {
              "valueKey": "lease-$/sqft",
              "value": [
                  [
                      0
                  ]
              ]
          },
          "lease-term-years": {
              "valueKey": "lease-term-years",
              "value": [
                  [
                      25
                  ]
              ]
          },
          "lease-escalator": {
              "valueKey": "lease-escalator",
              "value": [
                  [
                      2
                  ]
              ]
          }
        }
      }
      setScenario(scenarioRecord);
      setScenarioStatus(scenarioRecord.status);
    }
   setLoading(true);
    load().catch(e => errorMessage(e.message)).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if ((resultantStore || running) && resultBlockRef.current) {
      resultBlockRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [resultantStore, running]);

  if (loading || !scenario || !QATProjectId) return <LoadingBlock/>;

  const updateScenario = async () => {
    try {
      await updateWhatIfScenario(companyId, scenario.scenarioId, {
        projectVersions: scenario.inputData.projectVersions,
        globalInputs: scenario.inputData.globalInputs,
        parameters: undefined,
        projectVersionInputs: scenario.inputData.projectVersionInputs,
        scenarioName: scenario.scenarioName,
        modelId: scenario?.modelId ?? undefined,
      })
    } catch (e: any) {
      console.error(`Error updating scenario. ${e.message}`)
      errorMessage(`Error ingesting the provided inputs`);
      throw e;
    }
  }

  const continueToProject = () => {
    history.push(amProjectDetails(QATProjectId));
  }

  const runScenario = async () => {
    clear();
    setRunning(true);
    // setResults(undefined);
    setResultantStore(undefined);
    setVersionData(undefined);
    await updateScenario();
    setScenarioStatus("started");

    try {
      // @TODO: CHECK THIS AGAIN
      const result = await runWhatIfScenarioDirectlyForQAT(companyId, scenario.scenarioId, QATProjectId, "[new]");
      if(result.type === "error") {
        errorMessage("Something went wrong please try again");
        setScenarioStatus("failed");
        return;
      } else if (result?.newVersion && result?.newVersion?.versionData) {
        const store = await persistence.loadLineItemsStore(collection, getStoreId(QATProjectId, result?.newVersion?.versionData?.versionId), false)
        setScenarioStatus("completed");
        setResultantStore(store);
        setVersionData(result?.newVersion.versionData);
      } else if(result.newVersion && !result?.newVersion?.versionData) {
        showMappingErrors({...result?.newVersion}, openPopup, ()=>{
          setRunning(false);
          closePopup();
        }, continueToProject);
      }
    } catch(e: any){
      errorMessage(`Error running scenario. ${e.message}`)
    } finally {
      setRunning(false);
    }
  }

  const handleScenarioInputUpdate = (data:  WhatIfScenarioRecord['inputData']) => {
    setScenario({...scenario, inputData: data})
  }

  const canRunScenario = scenarioStatus && (isFinalStateOfScenario(scenarioStatus) || scenarioStatus === "new");

  const UX_STRINGS = getStringsByWhatIfKind(kind === 'CPFAT' ? 'Create-Project' : kind);

  const title = UX_STRINGS.title;
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: '32px 24px'
    }}>
      <div style={{ maxWidth: '1600px', margin: '0 auto' }}>
      {(kind === 'CPFAT' || kind === 'Create-Project') && <Button primary
                floated={"right"}
                style={{marginBottom: "1em"}}
                size={"small"}
                disabled={running}
                onClick={()=>history.push(developmentProjectsProjectsList())}
        >Show Project List</Button>}
        {/* Navigation Header */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          marginBottom: '40px',
          padding: '20px 0'
        }}>
          <div>
            <h1 style={{ 
              margin: 0, 
              fontSize: '32px', 
              fontWeight: '600', 
              color: '#2c3e50',
              letterSpacing: '-0.5px',
              lineHeight: '1.2'
            }}>
              {title}
            </h1>
          </div>
        </div>

        {/* Results Section */}
        <div ref={resultBlockRef}>
        {(resultantStore || running) && (
          <PSCard>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '32px',
              paddingBottom: '20px',
              borderBottom: '1px solid #f1f3f4'
            }}>
              <div style={{ 
                width: '48px', 
                height: '48px', 
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '20px'
              }}>
                <Icon name='chart line' inverted size="large" />
              </div>
              <div>
                <h2 style={{ 
                  margin: 0, 
                  fontSize: '28px', 
                  fontWeight: '600', 
                  color: '#2c3e50',
                  lineHeight: '1.3'
                }}>
                  {resultantStore ? UX_STRINGS.resultsBlock.readyTitle : UX_STRINGS.resultsBlock.title}
                </h2>
              </div>
            </div>
            {(resultantStore && kind === 'PFA') && <PFAResultBlock store={resultantStore} versionData={versionData} QATProjectId={QATProjectId} />}
            {(resultantStore && kind === "Project-Pricing") && <ProjectPricingResultBlock store={resultantStore} versionData={versionData} QATProjectId={QATProjectId} />}
            {(resultantStore && kind === "Create-Project") && <ProjectCreationResultBlock store={resultantStore} versionData={versionData} QATProjectId={QATProjectId} />}
            {(resultantStore && kind === "CPFAT") && <CPFATResultBlock store={resultantStore} versionData={versionData} QATProjectId={QATProjectId} />}

            {running && (
                          <div>
                          <h3 style={{ 
                            margin: 0, 
                            fontSize: '20px', 
                            fontWeight: '600', 
                            color: '#2c3e50',
                            lineHeight: '1.3'
                          }}>
                            {'Running'}
                          </h3>
                          <p style={{ 
                            margin: '4px 0 0 0', 
                            fontSize: '16px', 
                            color: '#6c757d',
                            lineHeight: '1.4'
                          }}>
                            {(kind === 'Create-Project' || kind === 'CPFAT') ? 'Your project is being evaluated. This process may take a few minutes to complete. Please wait while we qualify your project.' : `Your ${kind.split("-").join(" ")} scenario analysis is currently running. This process may take a few minutes to complete. Please wait while we process your financial data.`}
                          </p>
                          <div style={{ 
              textAlign: 'center', 
              padding: '20px',
              background: 'rgba(0, 123, 255, 0.05)',
              borderRadius: '12px',
              border: '1px solid rgba(0, 123, 255, 0.2)'
            }}>
              <Icon name='spinner' loading size="large" style={{ color: '#007bff', marginBottom: '12px' }} />
              <p style={{ 
                margin: '8px 0 0 0', 
                fontSize: '16px', 
                color: '#007bff',
                fontWeight: '500'
              }}>
                {UX_STRINGS.resultsBlock.text}
              </p>
            </div>
                        </div>

          )}
          </PSCard>
        )}
  </div>

        {/* Biographical + Main Content Side by Side */}
        <PSCard id="icp4">
        <div style={{
          display: 'flex',
          gap: '32px',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          marginBottom: '40px'
        }}>
        {(kind !== 'Create-Project' && kind !== 'CPFAT') && <div style={{ flex: 1, minWidth: 340, maxWidth: 480 }}>
        <Box
                        component="form"
                        className="formContainer"
                        onSubmit={handleSubmit}
                    >
                          <div className="formHeader">
                            <Typography variant="h2" component="h2">
                            Biographical Information
                            </Typography>
                            <Typography variant="body2">
                            Please provide the following information to help us better understand your organization and project.
                            </Typography>
                        </div>
                        {/* First Name */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="First Name"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                        </Box>

                        {/* Last Name */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="Last Name"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                        </Box>

                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="Title"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                            />
                        </Box>
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="Organization"
                                name="userProvidedCompanyName"
                                value={formData.userProvidedCompanyName}
                                onChange={handleChange}
                            />
                        </Box>
                        {/* Business Email */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                type="email"
                                label="Business Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Box>

                        <Box className="field">
                        <TextField
                                fullWidth
                                required
                                label="Phone Number"
                                name="phoneNumber"
                                value={formData.phoneData.phoneNumber}
                                onChange={(e)=>{
                                 handleChange({target: {name: 'phoneData', value: {
                                  ...formData.phoneData,
                                  phoneNumber: e.target.value
                                 }}});
                                }}
                            />
                        </Box>
        </Box>
        </div>}
        {config && <div style={{ flex: 2, minWidth: 340 }}>
          <PSCard>
          <div style={{ 
              width: '100%',
              maxWidth: 'none',
              margin: '0',
              padding: '0'
            }}>
              <div>
                <GlobalInputs
                  config={config}
                  inputData={scenario.inputData}
                  updateInputData={handleScenarioInputUpdate}
                  renderHeaderSection={false}
                  compact={true}
                  {...(kind === 'Create-Project' || kind === 'CPFAT') ? {sectioningByWorksheet: {
                    customMapping: {
                      "Project and System Size Inputs": [
                        "Project Name",
                        "Construction Start Month (mm/yyyy)",
                        // "Construction Period (In Months)",
                        "Project Lifetime (In Years)",
                        // "Address Line-1",
                        // "County",
                        "State",
                        // "Zip Code",
                        "PV System Size (kW DC)",
                        "PV System Size (kW AC)",
                        "Avoided Rate ($/kWh)",
                        // "Discount (%)",
                        "Desired PPA Rate ($/kWh)",
                        "PPA Rate Escalator (%)",
                       ],
                      "Perl Street Inputs": [
                        "3P Professional Services Fee (%)",
                        "3P Per Unit Set Up Fees",
                        "PV System O&M ($/kW)",
                        "3P Unit Billing Fees ($/Unit/Month)",  
                        "3P Unit Billing Fees Inflation Rate (%)",
                        "PS Asset Management Fee ($/Unit/Year)",
                        "PS Asset Management Fee Period (Years)",
                        "PS Arrangement Fee on ITC (%)",
                        "PS Arrangement Fee on Debt (%)",
                        "PS Arrangement Fee on Equity (%)"
                       ],
                       "Desired Financing and Other Inputs": [
                        "System Cost ($/watt dc)",
                        "Debt Interest Rate (%)",
                        "Debt Term (Years)",
                        "Surface Area (sqft)",
                        "Desired Lease $/sqft ($)",
                        "Lease Term (Years)",
                        "Lease Escalator (%)"
                       ],
                    }
                  }, useDatePickersForDateInputs: true} : {}}
                />
                {/* @TODO: Add separate for CPFAT */}
              </div>
            </div>
          </PSCard>

        </div>}
        </div>
        </PSCard>
    </div>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          padding: '20px 0'
        }}>
          <SemanticButton 
            size="large"
            primary
            loading={running}
            disabled={!canRunScenario}
            onClick={runScenario}
            style={{ 
              background: 'linear-gradient(135deg, #480971 0%, #6435C9 100%)',
              border: 'none',
              borderRadius: '12px',
              padding: '18px 36px',
              fontSize: '18px',
              fontWeight: '600',
              boxShadow: '0 6px 20px rgba(72, 9, 113, 0.3)',
              transition: 'all 0.2s ease',
              minWidth: '200px'
            }}
          >
            <Icon name='play' />
            {running ? UX_STRINGS.button.loadingText : UX_STRINGS.button.text}
          </SemanticButton>
      </div>
    </div>
  );
}

const getStringsByWhatIfKind = (kind: "PFA" | "Project-Pricing" | "Create-Project") => {
  switch(kind) {
    case "PFA":
      return {
        title:'Preliminary Financial Analysis Tool',
        resultsBlock: {
          text:'Processing your scenario analysis...',
          title: 'Running Analysis...',
          readyTitle: 'Analysis Results'
        },
        button: {
          text: 'Submit for Pre-Qualification',
          loadingText: 'Running Analysis...',
        }
      }
    case "Project-Pricing":
      return {
        title: 'Project Pricing Tool',
        resultsBlock: {
          text:'Processing your scenario analysis...',
          title: 'Running Analysis...',
          readyTitle: 'Analysis Results'
        },
        button: {
          text: 'Calculate Project Pricing',
          loadingText: 'Running Analysis...',
        }
      }
    case "Create-Project":
      return {
        title: 'QuickBuild Project Qualification Tool',
        resultsBlock: {
          text:'Qualifying your Project',
          title: 'Qualifying your Project...',
          readyTitle: 'QuickBuild Project Qualification Results'
        },
        button: {
          text: 'Submit Project for Qualification',
          loadingText: 'Qualifying your Project',
        }
      }
  }
}

export const showMappingErrors = (
  messages: { errors?: string[]; warnings: string[] },
  openPopup: (element: JSX.Element) => void,
  closePopup: () => void,
  continueToProject?: () => void
) => {
  const { errors: mappingErrors, warnings: mappingWarnings } = messages;
  const hasErrors = (mappingErrors ?? []).length > 0;
  const hasWarnings = mappingWarnings.length > 0;
  const popUpContentHeader = hasErrors
    ? "Version Creation Failed because the following problems were encountered while parsing the supplied excel"
    : "The version was created but with the following warnings";
  if (hasErrors || hasWarnings) {
    openPopup(
      <ContentPopup
        header={""}
        size={"small"}
        onClose={closePopup}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header size="small">{popUpContentHeader}</Header>
        <>
          <ProjectVersionMappingLogs messages={messages} />
          {hasErrors && (
            <>
              <Button onClick={() => closePopup()}>Update Inputs</Button>
            </>
          )}
          {continueToProject && <Button
            floated={hasErrors ? "right" : "left"}
            onClick={() => continueToProject()}
          >
            Go Back To Project
          </Button>}
        </>
      </ContentPopup>
    );
  }
};